import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'curbnturf-rating-incremental',
  templateUrl: './rating-incremental.component.html',
  styleUrls: ['./rating-incremental.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingIncrementalComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RatingIncrementalComponent),
      multi: true,
    },
  ],
  standalone: true,
})
export class RatingIncrementalComponent {
  @Input() value: number = 0;

  @Input() label: string;

  @Input() disabled: boolean = false;

  @Input() min: number = 0;

  @Input() max: number = 100;

  @Input() incrementAmount: number = 1;

  @Output() selectChange: EventEmitter<number> = new EventEmitter<number>();

  onChange: (id?: number) => void = () => {
    /**/
  };
  onTouched: (id?: number) => void = () => {
    /**/
  };

  writeValue(amount: number): void {
    this.value = amount;
  }

  registerOnChange(fn: (id?: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (id?: number) => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate({ value }: FormControl) {
    const isNotValid = value <= this.min || value > this.max;
    return (
      isNotValid && {
        invalid: true,
      }
    );
  }

  onIncrement() {
    if (!this.disabled) {
      if (this.value < this.max) {
        this.value++;
        this.selectChange.emit(this.value);
        this.onChange(this.value);
        this.onTouched();
      }
    }
  }

  onDecrement() {
    if (!this.disabled) {
      if (this.value > this.min) {
        this.value--;
        this.selectChange.emit(this.value);
        this.onChange(this.value);
        this.onTouched();
      }
    }
  }
}
